import { useState } from "react";
import ExcelJS from "exceljs";
import moment from "moment";

import sdk from "@/sdk";

const columns = [
  { header: "Овог", key: "lastName" },
  { header: "Нэр", key: "firstName" },
  { header: "Утасны дугаар", key: "phoneNo" },
  { header: "И-мэйл", key: "email" },
  { header: "Регистрийн дугаар", key: "registerNo" },
  { header: "ТТД", key: "taxPayerNo" },
  { header: "Бүтээгдэхүүний нэр", key: "bondName" },
  { header: "Жилийн хүү", key: "interestRate" },
  { header: "Захиалгын огноо", key: "purchaseDate" },
  { header: "Үндсэн дүн", key: "principleAmount" },
  { header: "Олгосон хүү", key: "totalInterest" },
  { header: "Татвар", key: "totalTax" },
  { header: "Шимтгэл", key: "fee" },
  { header: "Сүүлийн хүү олголт", key: "lastPayoutAt" },
];

export function useBondHoldersExcel(bondId: string) {
  const [loading, setLoading] = useState(false);

  const generateExcel = async () => {
    setLoading(true);
    try {
      const { bondHolders } = await sdk.bondHolders({
        bondId,
        page: 0,
        limit: 10000,
      });

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Худалдан авалтууд");

      worksheet.columns = columns.map((column) => ({
        ...column,
        width: Math.max(14, column.header.length + 2),
      }));

      bondHolders.holders.forEach((holder) => {
        worksheet.addRow({
          lastName: holder.lastName ?? "",
          firstName: holder.firstName ?? "",
          phoneNo: holder.phoneNo ?? "",
          email: holder.email ?? "",
          registerNo: holder.registerNo ?? "",
          taxPayerNo: holder.taxPayerNo ?? "",
          bondName: holder.bondName ?? "",
          interestRate: holder.interestRate ? `${holder.interestRate}%` : "",
          purchaseDate: holder.purchaseDate
            ? moment(holder.purchaseDate).format("YYYY-MM-DD")
            : "-",
          principleAmount: holder.principleAmount,
          totalInterest: holder.totalInterest ?? 0,
          totalTax: holder.totalTax ?? 0,
          fee: holder.fee ?? 0,
          lastPayoutAt: holder.lastPayoutAt
            ? moment(holder.lastPayoutAt).format("YYYY-MM-DD")
            : "-",
        });
      });

      const blob = new Blob([await workbook.xlsx.writeBuffer()], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    } finally {
      setLoading(false);
    }
  };

  return { generateExcel, loading };
}
